module.exports = __webpack_public_path__ + "img/menu-alarm.ebffda3c.svg";